import store from '../index'

export function clearData() {
  store.dispatch('ClearUser');
  store.dispatch('ClearApp');
  store.dispatch('ClearPermission');
  store.dispatch('ClearTabs');
}



// WEBPACK FOOTER //
// ./src/store/modules/clearData.js